import { useEffect } from 'react';
import AttendanceChallengeBoard from './AttendanceChallengeBoard';

export default function AttendanceBottomSheet({
  open,
  data,
  onCta,
  busy,
  onClose,
  onShown,
}) {
  useEffect(() => {
    if (open) {
      onShown?.();
    }
  }, [open, onShown]);

  if (!open || !data) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[111] flex items-end justify-center bg-black/55"
      role="dialog"
      aria-modal="true"
      aria-label="출석체크 챌린지"
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="relative w-full max-w-[500px] rounded-t-2xl bg-background01 pb-6 pt-3 shadow-lg">
        <div className="mx-auto mb-2 h-1 w-9 rounded-full bg-gray03/40" />
        <button
          type="button"
          className="absolute right-2 top-2 z-10 flex h-11 w-11 items-center justify-center border-0 bg-transparent p-0 text-2xl leading-none text-gray05 outline-none"
          aria-label="닫기"
          onClick={(event) => {
            event.stopPropagation();
            onClose();
          }}
        >
          ×
        </button>
        <AttendanceChallengeBoard data={data} onCta={onCta} busy={busy} compact />
      </div>
    </div>
  );
}
